export type FeatureFlagEnv = {
  VITE_NEWSLETTER_SIGNUP_ENABLED?: string;
  VITE_HOMEPAGE_HEAT_ENABLED?: string;
  VITE_RECEIPT_SHARING_ENABLED?: string;
  VITE_WATCHLIST_HOME_V2_ENABLED?: string;
};

function readCurrentEnv(): FeatureFlagEnv {
  const maybeEnv = (import.meta as ImportMeta & { env?: FeatureFlagEnv }).env;
  return maybeEnv ?? {};
}

export function isFeatureEnabled(value: unknown): boolean {
  return String(value ?? '').trim().toLowerCase() === 'true';
}

export function getFeatureFlags(env: FeatureFlagEnv = readCurrentEnv()) {
  return {
    newsletterSignup: isFeatureEnabled(env.VITE_NEWSLETTER_SIGNUP_ENABLED),
    homepageHeat: isFeatureEnabled(env.VITE_HOMEPAGE_HEAT_ENABLED),
    receiptSharing: isFeatureEnabled(env.VITE_RECEIPT_SHARING_ENABLED),
    watchlistHomeV2: isFeatureEnabled(env.VITE_WATCHLIST_HOME_V2_ENABLED),
  };
}

export const featureFlags = getFeatureFlags();
